import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import DVRTypeTable from "./view/DVRTypeTable";

interface DVRTypeProps {}
export const DVRType: React.FC<DVRTypeProps> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_dvrtype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <> {userPermissions.includes(viewPermission) && <DVRTypeTable />} </>;
};
export default DVRType;
